import { ChartArea } from "chart.js";
import React, { useEffect, useRef, useState } from "react";

interface DraggableLineControlProps {
	chartArea: ChartArea;
	initialLeft: number;
	otherLineCoord: number;
	onUpdate: (newLeft: number) => void;
	color: string;
}

const DraggableLineControl: React.FC<DraggableLineControlProps> = ({
	initialLeft,
	otherLineCoord,
	onUpdate,
	color,
	chartArea,
}) => {
	const [isDragging, setIsDragging] = useState(false);
	const [left, setLeft] = useState(initialLeft);
	const ref = useRef<HTMLDivElement>(null);

	const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
		setIsDragging(true);
		e.stopPropagation();
		e.preventDefault();
	};

	const handleMouseMove = (e: MouseEvent) => {
		if (!isDragging || !ref.current) return;

		const rightPadding = chartArea.width - chartArea.right;
		const leftPadding = chartArea.left;

		let newLeft = Math.min(
			Math.max(
				e.clientX - ref.current.offsetParent!.getBoundingClientRect().left,
				chartArea.left,
			),
			chartArea.right,
		);

		// Line limit
		if (color === "red" && newLeft > otherLineCoord - 20) {
			newLeft = otherLineCoord - 20;
		} else if (color === "blue" && newLeft < otherLineCoord + 20) {
			newLeft = otherLineCoord + 20;
		}

		setLeft(newLeft);
		onUpdate(newLeft); // Actualiza la posición de la línea en el gráfico
	};

	const handleMouseUp = () => {
		setIsDragging(false);
	};

	useEffect(() => {
		const mouseMoveHandler = (e: MouseEvent) => handleMouseMove(e);
		const mouseUpHandler = () => handleMouseUp();

		if (isDragging) {
			window.addEventListener("mousemove", mouseMoveHandler);
			window.addEventListener("mouseup", mouseUpHandler);
		}

		return () => {
			window.removeEventListener("mousemove", mouseMoveHandler);
			window.removeEventListener("mouseup", mouseUpHandler);
		};
	}, [isDragging]);

	return (
		<div
			ref={ref}
			style={{
				height: 20,
				width: 20,
				background: color,
				position: "absolute",
				top: -10,
				left: left - 10,
			}}
			onMouseDown={handleMouseDown}
		>
			<div
				style={{
					height: chartArea.height,
					width: 2,
					background: color,
					position: "relative",
					top: 20,
					left: 0,
					right: 0,
					margin: "auto",
				}}
			></div>
		</div>
	);
};

export default DraggableLineControl;
